import { render, staticRenderFns } from "./formContacto.vue?vue&type=template&id=2d2e1a62&scoped=true&"
import script from "./formContacto.vue?vue&type=script&lang=js&"
export * from "./formContacto.vue?vue&type=script&lang=js&"
import style0 from "./formContacto.vue?vue&type=style&index=0&id=2d2e1a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e1a62",
  null
  
)

export default component.exports